<script lang="ts">
	let className = ''
	export { className as class }
	export let showSubItems = false

	$: transform = showSubItems ? 'rotate(90)' : ''
</script>

<!-- arrow-square-right.svg -->
<svg
	class="stroke-current {className} "
	{transform}
	width="14"
	height="14"
	viewBox="0 0 14 14"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M5.24984 12.8334H8.74984C11.6665 12.8334 12.8332 11.6667 12.8332 8.75002V5.25002C12.8332 2.33335 11.6665 1.16669 8.74984 1.16669H5.24984C2.33317 1.16669 1.1665 2.33335 1.1665 5.25002V8.75002C1.1665 11.6667 2.33317 12.8334 5.24984 12.8334Z"
		stroke=""
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M6.26514 9.05919L8.31847 7.00002L6.26514 4.94086"
		stroke=""
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
